export default __webpack_public_path__ + "static/media/project-settings-icon.c93b1838.svg";